import { render, staticRenderFns } from "./Q10info.vue?vue&type=template&id=b54a16d0&"
import script from "./Q10info.vue?vue&type=script&lang=ts&"
export * from "./Q10info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports